'use strict';

angular.module('ntmApp').factory('ProfilePage', ['$q', 'ProfileDataService', 'ProfileMenu', 'ProfileFilters', 'ProfileHelper', 'GridService', 'FormService', 'PreviewScheduleService', 'ProfileConstants', 'ListGridConstants',
    function ($q, ProfileDataService, ProfileMenu, ProfileFilters, ProfileHelper, GridService, FormService, PreviewScheduleService, ProfileConstants, ListGridConstants) {

    function ProfilePage() {

        var self = this;

        self.DefaultNames = {
            AddButtonName: ProfileConstants.DefaultNames.AddButtonName
        };
        
        var profileDataService = new ProfileDataService();
        var profileMenu = new ProfileMenu();

        self.profileFilters = new ProfileFilters();

        self.getProfilePage = function () {

            var deferred = $q.defer();

            self.loaded = false;

            GridService.GetProfilePage(ProfileHelper.pageId).then(function (result) {

                if (result.success) {
                    result.data.filters = self.profileFilters.buildFilters(result.data.profileFilter);
                }

                self.loaded = true;

                deferred.resolve(result.data);
            });

            return deferred.promise;
        };

        self.getProfileMenu = function (filters) {

            var deferred = $q.defer();

            var data = self.profileFilters.getRequestData(filters);

            GridService.GetProfileMenu(data).then(function (result) {

                self.profileFilters.onFiltersApplied();

                var menu = profileMenu.buildMenu(result.data);
                
                deferred.resolve(menu);
            });

            return deferred.promise;
        };

        self.getAddNewPageData = function () {

            var deferred = $q.defer();

            GridService.GetAddNewPage(ProfileHelper.pageId).then(function (result) {

                var data = { colunmSections: result.data };

                deferred.resolve(profileDataService.processProfilePageData(data, ProfileConstants.EditTypes.ADD));
            });

            return deferred.promise;
        };

        self.deletePage = function (item) {

            var deferred = $q.defer();

            var data = {
                pageId: ProfileHelper.pageId,
                action: ListGridConstants.Operation.DELETE,
                pageType: ListGridConstants.SectionType.GeneralPage,
                sections: [{
                    data: {},
                    primaryKeys: item.keys,
                    sectionId: profileDataService.getInfoSectionId()
                }]
            };

            GridService.Save(data).then(function (result) {
                deferred.resolve({success: result.success, message: result.data.message});                
            });

            return deferred.promise;

        };

        self.getProfileData = function (item, scope) {

            var deferred = $q.defer();

            var data = {
                pageId: ProfileHelper.pageId,
                keyFilters: item.entity
            };

            self.alerts = [];

            GridService.GetProfileData(data).then(function (result) {
                self.pageAnimation = result.data.pageAnimation;
                deferred.resolve(profileDataService.processProfilePageData(result.data, ProfileConstants.EditTypes.EDIT, item.entity, scope));

                self.GetRoomPreviewAlerts();
            });

            return deferred.promise;
        };

        self.GetRoomPreviewAlerts = function () {
            if (profileDataService.hasRoomPreview) {
                PreviewScheduleService.GetRoomPreviewAlerts(ProfileHelper.keyFilters).then(function (result) {
                    if (result.success) {
                      self.alerts = result.data.alerts;

                      if (self.profileItem)
                        updatePageItemData(result.data.newProfileItem, self.profileItem);
                    }
                });
            }
        };

      self.onSectionSave = function (updatedData, selectedProfileMenuItem) {
        self.GetRoomPreviewAlerts();
        updatePageItemData(updatedData.newProfileItem, selectedProfileMenuItem);
      }

      updatePageItemData = function (newProfileItem, selectedProfileMenuItem) {

          if (!newProfileItem) {
             return;
          }

        profileMenu.updateMenuItem(selectedProfileMenuItem, newProfileItem);
      }

        self.processRoomPreviewData = function (roomPreviewData) {
            return profileDataService.processRoomPreviewData(roomPreviewData);
        };

        self.filterMenu = function (filters) {

            var deferred = $q.defer();

            self.getProfileMenu(filters).then(function (result) {
                deferred.resolve(result.data);
            });

            return deferred.promise;
        };

        self.onFiltersDialogCloseXClicked = function (callback) {
            self.profileFilters.onFiltersDialogCloseXClicked(callback);
        };

        self.hasAlerts = function () {
            return profileDataService.hasRoomPreview && self.alerts && self.alerts.length > 0;
        };

        self.getAlertIcon = function (type) {
            switch (type) {
                case ProfileConstants.AlertTypes.MissingStaffWorkShift:
                    return 'assets/icons/roomProfileAlertIcons/room-staff-missing-work-shifts (clock-glyph-16).svg';
                case ProfileConstants.AlertTypes.MissingEquipment:
                    return 'assets/icons/roomProfileAlertIcons/missing-equipment (equipment-16).svg';
                case ProfileConstants.AlertTypes.MissingMetrics:
                    return 'assets/icons/roomProfileAlertIcons/missing-metrics (metric grid-16).svg';
                case ProfileConstants.AlertTypes.MissingRackItem:
                    return 'assets/icons/roomProfileAlertIcons/missing-rack-item (rack item-16).svg';
                case ProfileConstants.AlertTypes.MissingRacks:
                    return 'assets/icons/roomProfileAlertIcons/missing-rack (missing-rack-glyph-16).svg';
                case ProfileConstants.AlertTypes.MissingRecurrence:
                    return 'assets/icons/roomProfileAlertIcons/missing-recurrence (recurrence-16).svg';
                case ProfileConstants.AlertTypes.MissingSquareFootage:
                    return 'assets/icons/roomProfileAlertIcons/missing-square-footage (square footage-16).svg';
            }
        };

        self.isHighPriority = function (alerts) {
            return alerts.some(function (alert) { return alert.OrderPriority === 0; });
        };

        self.toJSON = function (obj) {
            return JSON.stringify(obj);
        };
    }

    return (ProfilePage);
    }]);
